/// new created

import api from 'services/api'
import {
    GET_BRANDS_LIST ,
    CREATE_BRAND,
    GET_BRAND_DETAIL,
    UPDATE_BRAND,
    Delete_BRAND,
} from '../endpoints'



export const getBrandsList = async (body) => await api.post(GET_BRANDS_LIST , body)

export const deleteBrand = async (id) =>  await api.delete(Delete_BRAND, {data: {brand_id: id}})
export const getBrandDetail = async (id) => await api.get(`${GET_BRAND_DETAIL}?brand_id=${id}`);
// export const getAdDetail = async (id) => await api.get(`${GET_AD_DETAIL}?ad_id=${id}`)
// export const getBrandDetail = async (id) => await api.get(`${GET_BRAND_DETAIL}/${id}`);


export const submitBrand = async (values, id) =>
    await api.post(id ? UPDATE_BRAND : CREATE_BRAND, values, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  
  